jQuery(document).ready(function ($) {
  var $blog = $(".box-carousel-blog .swiper");

  if (!$blog.length) return;

  $blog.each(function (index, element) {
    var mySwiper = new Swiper(element, {
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      slidesPerView: 1,
      spaceBetween: 20,
      speed: 500,
      // centerInsufficientSlides: true,
      rewind: true,
      navigation: {
        nextEl: $(element).parent().find(".carousel-navigation .next")[0],
        prevEl: $(element).parent().find(".carousel-navigation .prev")[0],
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
  });
});
